module.exports = __webpack_public_path__ + "static/ogrod-roslinnosc_thumb-59c4621aad157abf0e8cde0406157f0a.jpg";